import { setting } from "shared/types/Report";

const useHomeworkSettingView = (setSetting?: React.Dispatch<React.SetStateAction<setting | undefined>>) => {
    const onSettingChangeHandler = <T, >(type: keyof setting, name: string, value: T) => {
        if (setSetting) {
            setSetting(prevSetting => {
                if (!prevSetting) {
                    return undefined;
                }
                return {
                    ...prevSetting,
                    [type]: {
                        ...prevSetting[type],
                        [name]: value
                    }
                };
            });
        }
    }

    return { onSettingChangeHandler };
}

export default useHomeworkSettingView;
